import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import { useParams } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { useDropzone } from 'react-dropzone';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { FormControl, } from '@mui/material';
import {
    MaterialReactTable,

} from 'material-react-table';
import { Card, CardContent } from '@mui/material';

import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';


import DeleteIcon from '@mui/icons-material/Delete';


import { format, isValid, parse } from 'date-fns';

import AppBar from '@mui/material/AppBar';
import {
    Box,
    Tooltip
} from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Skeleton from '@material-ui/lab/Skeleton';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";

import { Stack } from '@mui/material';

import { Button, MenuItem, Select, InputLabel } from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { styled } from '@material-ui/styles';

import miniatura_pdf from '../../../../../../assets/imgs/miniatura_pdf.png';
import office from '../../../../../../assets/imgs/office.png';
import comprovante from '../../../../../../assets/imgs/comprovante.png';
import RequestQuoteIcon from '@mui/icons-material/Calculate';

import {
    DataGrid, 
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';

const drawerWidth = 240;




const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    table: {
        minWidth: 650,
    },
}));

const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};




export default function GeradorParcelas({ lancamento, closeGeradorParcelas }) {

    const [parcelas, setParcelas] = useState([]);
    const [loading, setLoading] = useState(true);

    const [numeroParcelas, setNumeroParcelas] = useState(0);
    const [tipoIntervalo, setTipoIntervalo] = useState(0);
    const [intervaloPrimeiraParcela, setIntervaloPrimeiraParcela] = useState(0);
    const [contaBancariaSelecionada, setContaBancariaSelecionada] = useState(null);
    const [contasBancarias, setContasBancarias] = useState(lancamento.fornecedor.contas_bancarias);

    const [tipoParcelamento, setTIpoParcelamento] = useState(0);

    const [repetirData, setRepetirData] = useState(false);
    const [tipoValor, setTipoValor] = useState("parcela");

    function returnDescricaoBanco(ib) {

        var texto = "Identificação: " + ib.identificacao +
            "\nTitular: " + ib.titular +
            "\nBanco: " + ib.banco +
            "\nAgência: " + ib.agencia +
            "\nConta: " + ib.conta +
            "\nDescrição: " + ib.descricao +
            "\nPix: " + ib.tipo_chave_1 + "=" + ib.chave_1;
        return texto;


    }

    const [intervaloParcelas, setIntervaloParcelas] = useState(0);
    const [intervaloVariavel, setIntervaloVariavel] = useState('');

    const [tipoDivisao, setTipoDivisao] = useState(0);
    const [divisaoVariavel, setDivisaoVariavel] = useState('');

    const [valorTotal, setValorTotal] = useState(0.0);

    const [preCotacao, setPreCotacao] = useState([]);
    const [metodosPagamento, setMetodosPagamento] = useState([]);

    const [metodoPagamento, setMetodoPagamento] = useState([]);


    const [condicaoPagamento, setCondicaoPagamento] = useState(null);
    const [condicoesPagamento, setCondicoesPagamento] = useState([]);

    function handleTipoParcelamento(tipo) {
        var local = null;

        if (tipo === 0) {
            if (condicaoPagamento !== null) {
                local = condicaoPagamento;
            }
        }
        else if (tipo === 1) {
            local = preCotacao;
        }

        if (local !== null) {
            setNumeroParcelas(local.numero_parcelas ?? 0);
            setTipoIntervalo(local.tipo_intervalo ?? 0);
            setIntervaloPrimeiraParcela(local.intervalo_primeira_parcela ?? 0);

            setIntervaloParcelas(local.intervalo_parcelas ?? 0);
            setIntervaloVariavel(local.intervalo_variavel ?? '');

            setTipoDivisao(local.tipo_divisao ?? 0);
            setDivisaoVariavel(local.divisao_variavel ?? '');

            // setValorTotal(local.valor_total ?? 0.0);
            setValorTotal(Number((local.valor_total ?? 0).toFixed(2)));


            try {
                setMetodoPagamento(local.metodos_pagamento?.[0] ?? null);
            } catch (error) {
                console.error("Erro ao definir método de pagamento:", error);
                setMetodoPagamento(null); // fallback seguro
            }

        }

        setTIpoParcelamento(tipo);

    }




    function handleCondicaoPagamento(local) {
        setCondicaoPagamento(local);

        if (local !== null) {
            try {
                setNumeroParcelas(local.numero_parcelas ?? 0);
            } catch (error) {
                console.error("Erro ao definir numero_parcelas:", error);
                setNumeroParcelas(0);
            }

            try {
                setTipoIntervalo(local.tipo_intervalo ?? 0);
            } catch (error) {
                console.error("Erro ao definir tipo_intervalo:", error);
                setTipoIntervalo(0);
            }

            try {
                setIntervaloPrimeiraParcela(local.intervalo_primeira_parcela ?? 0);
            } catch (error) {
                console.error("Erro ao definir intervalo_primeira_parcela:", error);
                setIntervaloPrimeiraParcela(0);
            }

            try {
                setIntervaloParcelas(local.intervalo_parcelas ?? 0);
            } catch (error) {
                console.error("Erro ao definir intervalo_parcelas:", error);
                setIntervaloParcelas(0);
            }

            try {
                setIntervaloVariavel(local.intervalo_variavel ?? '');
            } catch (error) {
                console.error("Erro ao definir intervalo_variavel:", error);
                setIntervaloVariavel('');
            }

            try {
                setTipoDivisao(local.tipo_divisao ?? 0);
            } catch (error) {
                console.error("Erro ao definir tipo_divisao:", error);
                setTipoDivisao(0);
            }

            try {
                setDivisaoVariavel(local.divisao_variavel ?? '');
            } catch (error) {
                console.error("Erro ao definir divisao_variavel:", error);
                setDivisaoVariavel('');
            }





        }

        try {
            setTIpoParcelamento(0);
        } catch (error) {
            console.error("Erro ao definir tipoParcelamento:", error);
            setTIpoParcelamento(0);
        }
    }


    /*
     function returnDescricaoCondicaoPagamento(condicao) {
            var texto = "ID_CONDICAO: " + condicao.id_condicao_pagamento + "\nNome: " + condicao.nome +
                "\nDescrição: " + condicao.descricao +
                "\nNúmero de Parcelas: " + condicao.numero_parcelas + " parcelas" +
                "\nTipo Intervalo de Parcelas: " + (condicao.tipo_intervalo === 0 ? " Fixo" : "Variavel") +
                "\nIntervalo de Parcelas:" + (condicao.tipo_intervalo === 0 ? ("parcelas a cada " + condicao.intervalo_parcelas + " dias") : (condicao.intervalo_variavel + " dias")) +
                "\nPrimeira parcela para: " + (condicao.intervalo_primeira_parcela === 0 ? " Ato da Compra" : "Em " + condicao.intervalo_primeira_parcela + " dias") +
                "\nTipo Divisão de Valores: " + (condicao.divisao_variavel === 0 ? "Parcelas com valores iguais" : condicao.divisao_variavel);
            return texto;
        }
            */

    function returnDescricaoCondicaoPagamento(condicao) {
        var texto = condicao.nome;
        return texto;
    }

    function returnDescricaoMetodoPagamento(metodo) {
        var texto = "Nome: " + metodo.nome +
            " | Codigo: " + metodo.codigo + " | Sigla: " + metodo.sigla;
        return texto;
    }


    function returnDescricaoMetodoPagamentoSimples(metodo) {
        var texto = metodo.nome;
        return texto;
    }


    async function listarInformacoes() {

        setLoading(true);

        if (lancamento.id_pre_cotacao < 0) {
            setLoading(false);
        } else {

            try {
                const token = Cookies.get('token');

                const headers = {
                    'Authorization': 'Bearer ' + token
                }


                await api.get("v1/protected/financeiro/metodospagamento/listartodos", {
                    headers: headers
                }).then(function (response) {


                    setMetodosPagamento(response.data)


                });

                await api.get("v1/protected/financeiro/condicoespagamento/listartodos", {
                    headers: headers
                }).then(function (response) {


                    setCondicoesPagamento(response.data)


                });

                if (lancamento.id_pre_cotacao) {
                    api.get("v1/protected/ordensdecompras/ordemdecompra/precotacao/listarporid/" + lancamento.id_pre_cotacao, {
                        headers: headers
                    }).then(function (response) {

                        setPreCotacao(response.data);
                        setTIpoParcelamento(1);


                        // mapeando cada campo do backend para os states do front
                        setNumeroParcelas(response.data.numero_parcelas ?? 0);
                        setTipoIntervalo(response.data.tipo_intervalo ?? 0);
                        setIntervaloPrimeiraParcela(response.data.intervalo_primeira_parcela ?? 0);

                        setContaBancariaSelecionada(response.data.conta_bancaria);


                        setIntervaloParcelas(response.data.intervalo_parcelas ?? 0);
                        setIntervaloVariavel(response.data.intervalo_variavel ?? '');

                        setTipoDivisao(response.data.tipo_divisao ?? 0);
                        setDivisaoVariavel(response.data.divisao_variavel ?? '');

                        //setValorTotal(response.data.valor_total ?? 0.0);
                        setValorTotal(Number((response.data.valor_total ?? 0).toFixed(2)));


                        try {
                            setMetodoPagamento(response?.data?.metodos_pagamento?.[0] ?? null);
                        } catch (error) {
                            console.error("Erro ao definir método de pagamento:", error);
                            setMetodoPagamento(null); // fallback seguro
                        }

                        setLoading(false);



                    });
                }
                setLoading(false);


            } catch (_err) {

                console.log("Erro ao listar objetos: " + _err)
                setLoading(false);

            }
        }

    }


    useEffect(() => {

        listarInformacoes();


    }, []);


    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    /*

    async function gerar() {
        // 1. Validar valor total
        if (!valorTotal || isNaN(valorTotal) || Number(valorTotal) <= 0) {
            alert("Informe um valor total válido e maior que zero");
            return;
        }

        // 2. Validar tipo de intervalo
        if (tipoIntervalo === 0) { // fixo
            if (!numeroParcelas || numeroParcelas <= 0) {
                alert("Número de parcelas inválido");
                return;
            }
            if (intervaloPrimeiraParcela === null || intervaloPrimeiraParcela === undefined || intervaloPrimeiraParcela === "") {
                alert("Informe o intervalo ou data da primeira parcela");
                return;
            }
            // Validar se é número ou data válida
            let isData = /^\d{2}\/\d{2}\/\d{4}$/.test(intervaloPrimeiraParcela);
            if (!isData && isNaN(intervaloPrimeiraParcela)) {
                alert("Intervalo da primeira parcela deve ser número ou data válida no formato dd/mm/yyyy");
                return;
            }
            if (!intervaloParcelas && numeroParcelas > 1) {
                alert("Informe o intervalo fixo entre as parcelas");
                return;
            }
        } else if (tipoIntervalo === 1) { // variável
            if (!intervaloVariavel) {
                alert("Informe o intervalo variável no formato (x,y,z)");
                return;
            }
        }

        // 3. Validar tipo de divisão
        if (tipoDivisao === 1 && !divisaoVariavel) {
            alert("Informe a divisão variável no formato (x,y,z)");
            return;
        }

        // 4. Criar parcelas
        let novasParcelas = [];
        let hoje = new Date();
        let dataPrimeira;

        // Calcular primeira data de vencimento
        let isData = /^\d{2}\/\d{2}\/\d{4}$/.test(intervaloPrimeiraParcela);
        if (isData) {
            let [d, m, a] = intervaloPrimeiraParcela.split("/");
            dataPrimeira = new Date(`${a}-${m}-${d}T00:00:00`);
        } else {
            dataPrimeira = new Date(hoje);
            dataPrimeira.setDate(dataPrimeira.getDate() + Number(intervaloPrimeiraParcela || 0));
        }

        // Função auxiliar para adicionar parcela
        function adicionarParcela(venc, valor) {
            let parcela = {
                data_vencimento: venc.toLocaleDateString("pt-BR"),
                valor: Number(valor),
            };
            if (metodoPagamento) {
                parcela.metodo_pagamento = metodoPagamento;
            }
            novasParcelas.push(parcela);
        }

        if (tipoIntervalo === 0) {
            // FIXO
            if (tipoDivisao === 0) {
                // Divisão igualitária
                let valorParcela = (Number(valorTotal) / numeroParcelas).toFixed(2);
                for (let i = 0; i < numeroParcelas; i++) {
                    let venc = new Date(dataPrimeira);
                    venc.setDate(venc.getDate() + (i * Number(intervaloParcelas)));
                    adicionarParcela(venc, valorParcela);
                }
            } else {
                // Divisão variável (valores ou %)
                let valores = divisaoVariavel.split(",").map(v => Number(v.trim()));
                let soma = valores.reduce((a, b) => a + b, 0);

                let usarPercentual = Math.abs(soma - 100) < 0.01;
                let somaCalculada = usarPercentual ? 100 : soma;

                if (Math.abs(somaCalculada - (usarPercentual ? 100 : Number(valorTotal))) > 0.01) {
                    alert("A soma das parcelas não bate com o valor total");
                    return;
                }

                for (let i = 0; i < valores.length; i++) {
                    let venc = new Date(dataPrimeira);
                    venc.setDate(venc.getDate() + (i * Number(intervaloParcelas)));
                    let valor = usarPercentual
                        ? ((valores[i] / 100) * Number(valorTotal)).toFixed(2)
                        : valores[i];
                    adicionarParcela(venc, valor);
                }
            }
        } else if (tipoIntervalo === 1) {
            // VARIÁVEL
            let intervalos = intervaloVariavel.split(",").map(v => Number(v.trim()));
            if (tipoDivisao === 0) {
                // Igualitária
                let valorParcela = (Number(valorTotal) / intervalos.length).toFixed(2);
                let dataAtual = new Date(dataPrimeira);
                for (let i = 0; i < intervalos.length; i++) {
                    dataAtual.setDate(dataAtual.getDate() + intervalos[i]);
                    adicionarParcela(new Date(dataAtual), valorParcela);
                }
            } else {
                // Variável (valores ou %)
                let valores = divisaoVariavel.split(",").map(v => Number(v.trim()));
                let soma = valores.reduce((a, b) => a + b, 0);

                let usarPercentual = Math.abs(soma - 100) < 0.01;
                let somaCalculada = usarPercentual ? 100 : soma;

                if (Math.abs(somaCalculada - (usarPercentual ? 100 : Number(valorTotal))) > 0.01) {
                    alert("A soma das parcelas não bate com o valor total");
                    return;
                }

                let dataAtual = new Date(dataPrimeira);
                for (let i = 0; i < valores.length; i++) {
                    dataAtual.setDate(dataAtual.getDate() + intervalos[i]);
                    let valor = usarPercentual
                        ? ((valores[i] / 100) * Number(valorTotal)).toFixed(2)
                        : valores[i];
                    adicionarParcela(new Date(dataAtual), valor);
                }
            }
        }

        // Atualizar estado
        setParcelas(novasParcelas);
        console.log("Parcelas geradas:", novasParcelas);
    }*/



    /*
        async function gerar() {
            // 1. Validar valor total
            if (!valorTotal || isNaN(valorTotal) || Number(valorTotal) <= 0) {
                alert("Informe um valor total válido e maior que zero");
                return;
            }
    
            // 2. Validar tipo de intervalo
            if (tipoIntervalo === 0) { // fixo
                if (!numeroParcelas || numeroParcelas <= 0) {
                    alert("Número de parcelas inválido");
                    return;
                }
                if (intervaloPrimeiraParcela === null || intervaloPrimeiraParcela === undefined || intervaloPrimeiraParcela === "") {
                    alert("Informe o intervalo ou data da primeira parcela");
                    return;
                }
                // Validar se é número ou data válida
                let isData = /^\d{2}\/\d{2}\/\d{4}$/.test(intervaloPrimeiraParcela);
                if (!isData && isNaN(intervaloPrimeiraParcela)) {
                    alert("Intervalo da primeira parcela deve ser número ou data válida no formato dd/mm/yyyy");
                    return;
                }
                if (!intervaloParcelas && numeroParcelas > 1) {
                    alert("Informe o intervalo fixo entre as parcelas");
                    return;
                }
            } else if (tipoIntervalo === 1) { // variável
                if (!intervaloVariavel) {
                    alert("Informe o intervalo variável no formato (x,y,z)");
                    return;
                }
            }
    
            // 3. Validar tipo de divisão
            if (tipoDivisao === 1 && !divisaoVariavel) {
                alert("Informe a divisão variável no formato (x,y,z)");
                return;
            }
    
            // 4. Criar parcelas
            let novasParcelas = [];
            let hoje = new Date();
            let dataPrimeira;
    
            // Calcular primeira data de vencimento
            let isData = /^\d{2}\/\d{2}\/\d{4}$/.test(intervaloPrimeiraParcela);
            if (isData) {
                let [d, m, a] = intervaloPrimeiraParcela.split("/");
                dataPrimeira = new Date(`${a}-${m}-${d}T00:00:00`);
            } else {
                dataPrimeira = new Date(hoje);
                dataPrimeira.setDate(dataPrimeira.getDate() + Number(intervaloPrimeiraParcela || 0));
            }
    
            // Função auxiliar para adicionar parcela
            function adicionarParcela(venc, valor) {
                let parcela = {
                    data_vencimento: venc.toLocaleDateString("pt-BR"),
                    valor: Number(valor),
                };
                if (metodoPagamento) {
                    parcela.metodo_pagamento = metodoPagamento;
                }
                novasParcelas.push(parcela);
            }
    
            if (tipoIntervalo === 0) { // FIXO
    
                // NOVA REGRA: repetir dia fixo se ativado
                const usarRepeticaoDia = repetirData === true
                    && Number(intervaloPrimeiraParcela) >= 0
                    && Number(intervaloPrimeiraParcela) <= 31
                    && Number(intervaloParcelas) > 0;
    
                if (tipoDivisao === 0) {
                    // Divisão igualitária
                    let valorParcela = (Number(valorTotal) / numeroParcelas).toFixed(2);
    
                    for (let i = 0; i < numeroParcelas; i++) {
                        let venc;
    
                        if (usarRepeticaoDia) {
                            venc = new Date(dataPrimeira);
    
                            let dia = Number(intervaloPrimeiraParcela);
    
                            // intervaloParcelas define a quantidade de dias, mas a repetição é por mês/ano
                            let meses = Math.floor((i * Number(intervaloParcelas)) / 30);
    
                            venc.setMonth(venc.getMonth() + meses);
    
                            // forçar manter o dia
                            venc.setDate(dia);
    
                        } else {
                            venc = new Date(dataPrimeira);
                            venc.setDate(venc.getDate() + (i * Number(intervaloParcelas)));
                        }
    
                        adicionarParcela(venc, valorParcela);
                    }
                }
                else {
                    // Divisão variável (valores ou %)
                    let valores = divisaoVariavel.split(",").map(v => Number(v.trim()));
                    let soma = valores.reduce((a, b) => a + b, 0);
                    let usarPercentual = Math.abs(soma - 100) < 0.01;
    
                    for (let i = 0; i < valores.length; i++) {
                        let venc;
    
                        if (usarRepeticaoDia) {
                            venc = new Date(dataPrimeira);
    
                            let dia = Number(intervaloPrimeiraParcela);
                            let meses = Math.floor((i * Number(intervaloParcelas)) / 30);
    
                            venc.setMonth(venc.getMonth() + meses);
                            venc.setDate(dia);
                        } else {
                            venc = new Date(dataPrimeira);
                            venc.setDate(venc.getDate() + (i * Number(intervaloParcelas)));
                        }
    
                        let valor = usarPercentual
                            ? ((valores[i] / 100) * Number(valorTotal)).toFixed(2)
                            : valores[i];
    
                        adicionarParcela(venc, valor);
                    }
                }
            }
    
            // Atualizar estado
            setParcelas(novasParcelas);
            console.log("Parcelas geradas:", novasParcelas);
        }
    */

    async function gerar() {
        // 1. Validar valor total
        if (!valorTotal || isNaN(valorTotal) || Number(valorTotal) <= 0) {
            alert("Informe um valor válido e maior que zero");
            return;
        }

        // 2. Validar tipo de intervalo
        if (tipoIntervalo === 0) { // fixo
            if (!numeroParcelas || numeroParcelas <= 0) {
                alert("Número de parcelas inválido");
                return;
            }
            if (!intervaloPrimeiraParcela) {
                alert("Informe o intervalo ou data da primeira parcela");
                return;
            }
            let isData = /^\d{2}\/\d{2}\/\d{4}$/.test(intervaloPrimeiraParcela);
            if (!isData && isNaN(intervaloPrimeiraParcela)) {
                alert("Intervalo da primeira parcela deve ser número ou data válida no formato dd/mm/yyyy");
                return;
            }
            if (!intervaloParcelas && numeroParcelas > 1) {
                alert("Informe o intervalo fixo entre as parcelas");
                return;
            }
        } else if (tipoIntervalo === 1) { // variável
            if (!intervaloVariavel) {
                alert("Informe o intervalo variável no formato (x,y,z)");
                return;
            }
        }

        // 3. Validar tipo de divisão
        if (tipoDivisao === 1 && !divisaoVariavel) {
            alert("Informe a divisão variável no formato (x,y,z)");
            return;
        }

        // 4. Criar parcelas
        let novasParcelas = [];
        let hoje = new Date();
        let dataPrimeira;

        // Calcular primeira data de vencimento
        let isData = /^\d{2}\/\d{2}\/{4}$/.test(intervaloPrimeiraParcela);
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(intervaloPrimeiraParcela)) {
            let [d, m, a] = intervaloPrimeiraParcela.split("/");
            dataPrimeira = new Date(`${a}-${m}-${d}T00:00:00`);
        } else {
            dataPrimeira = new Date(hoje);
            dataPrimeira.setDate(dataPrimeira.getDate() + Number(intervaloPrimeiraParcela || 0));
        }

        // Função para adicionar parcela
        function adicionarParcela(venc, valor) {
            let parcela = {
                data_vencimento: venc.toLocaleDateString("pt-BR"),
                valor: Number(valor),
            };
            if (metodoPagamento) parcela.metodo_pagamento = metodoPagamento;
            novasParcelas.push(parcela);
        }

        // --------------------------------------------
        //           PROCESSAMENTO DE PARCELAS
        // --------------------------------------------

        if (tipoIntervalo === 0) { // FIXO

            // NOVA REGRA: repetir dia fixo se ativado
            const usarRepeticaoDia =
                repetirData === true &&
                Number(intervaloPrimeiraParcela) >= 0 &&
                Number(intervaloPrimeiraParcela) <= 31 &&
                Number(intervaloParcelas) > 0;

            // =========================================================
            //              CASO TIPO VALOR = "parcela"
            // =========================================================
            if (tipoValor === "parcela") {

                for (let i = 0; i < numeroParcelas; i++) {
                    let venc;

                    if (usarRepeticaoDia) {
                        venc = new Date(dataPrimeira);
                        let dia = Number(intervaloPrimeiraParcela);
                        let meses = Math.floor((i * Number(intervaloParcelas)) / 30);
                        venc.setMonth(venc.getMonth() + meses);
                        venc.setDate(dia);
                    } else {
                        venc = new Date(dataPrimeira);
                        venc.setDate(venc.getDate() + (i * Number(intervaloParcelas)));
                    }

                    adicionarParcela(venc, Number(valorTotal)); // valor direto por parcela
                }

            }
            // =========================================================
            //              CASO TIPO VALOR = "total"
            // =========================================================
            else if (tipoValor === "total") {

                // --------------------- Divisão igualitária ---------------------
                if (tipoDivisao === 0) {
                    let valorParcela = (Number(valorTotal) / numeroParcelas).toFixed(2);

                    for (let i = 0; i < numeroParcelas; i++) {
                        let venc;

                        if (usarRepeticaoDia) {
                            venc = new Date(dataPrimeira);
                            let dia = Number(intervaloPrimeiraParcela);
                            let meses = Math.floor((i * Number(intervaloParcelas)) / 30);
                            venc.setMonth(venc.getMonth() + meses);
                            venc.setDate(dia);
                        } else {
                            venc = new Date(dataPrimeira);
                            venc.setDate(venc.getDate() + (i * Number(intervaloParcelas)));
                        }

                        adicionarParcela(venc, valorParcela);
                    }
                }

                // --------------------- Divisão variável ---------------------
                else {
                    let valores = divisaoVariavel.split(",").map(v => Number(v.trim()));
                    let soma = valores.reduce((a, b) => a + b, 0);
                    let usarPercentual = Math.abs(soma - 100) < 0.01;

                    for (let i = 0; i < valores.length; i++) {
                        let venc;

                        if (usarRepeticaoDia) {
                            venc = new Date(dataPrimeira);
                            let dia = Number(intervaloPrimeiraParcela);
                            let meses = Math.floor((i * Number(intervaloParcelas)) / 30);
                            venc.setMonth(venc.getMonth() + meses);
                            venc.setDate(dia);
                        } else {
                            venc = new Date(dataPrimeira);
                            venc.setDate(venc.getDate() + (i * Number(intervaloParcelas)));
                        }

                        let valor = usarPercentual
                            ? ((valores[i] / 100) * Number(valorTotal)).toFixed(2)
                            : valores[i];

                        adicionarParcela(venc, valor);
                    }
                }
            }
        }

        // Atualizar estado
        setParcelas(novasParcelas);
        console.log("Parcelas geradas:", novasParcelas);
    }


    function formatDateToISO(date) {
        if (!date) return null;

        // Se já estiver no formato ISO (yyyy-MM-dd), apenas retorna
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
            return date;
        }

        // Se vier no formato dd/MM/yyyy
        const [dia, mes, ano] = date.split("/");
        return `${ano}-${mes}-${dia}`;
    }

    async function salvar() {
        try {
            var id_user = Cookies.get("id_usuario");

            if (!parcelas || parcelas.length === 0) {
                alert("Defina as parcelas!");
                return;
            }

            // Normaliza todas as datas antes de enviar
            const parcelasFormatadas = parcelas.map((p) => ({
                ...p,
                data_vencimento: formatDateToISO(p.data_vencimento),
            }));

            // ✅ Validação extra só se houver pré-cotação
            if (lancamento.id_pre_cotacao && lancamento.id_pre_cotacao !== 0) {
                const somaExistentes = (lancamento.parcelas || []).reduce(
                    (total, p) => total + (parseFloat(p.valor) || 0),
                    0
                );

                const somaNovas = parcelasFormatadas.reduce(
                    (total, p) => total + (parseFloat(p.valor) || 0),
                    0
                );

                const comparador = Number(lancamento.valor ?? 0).toFixed(2);

                if (somaExistentes + somaNovas > comparador) {
                    alert("O valor total das parcelas não pode ultrapassar o valor do lançamento!");
                    return;
                }
            }

            const headers = {
                Authorization: "Bearer " + Cookies.get("token"),
            };

            const response = await api.post(
                `/v1/protected/financeiro/lancamentos/parcelas/cadastrarmultiplas/${id_user}/${lancamento.id_lancamento}`,
                parcelasFormatadas,
                { headers }
            );

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Parcelas Cadastradas!");
                closeGeradorParcelas();
            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente!");
        }
    }


    const columnsParcelas = [
        {
            accessorKey: 'valor',
            header: 'Valor Total',
            size: 120,
            Cell: ({ cell, row }) => (
                <TextField
                    type="text" // trocado de "number" -> "text" para remover setas
                    value={cell.getValue() || ''}
                    onChange={(e) => {
                        // Mantém apenas números e ponto
                        const newValue = e.target.value.replace(/[^\d.]/g, "");

                        setParcelas((prev) =>
                            prev.map((p, idx) =>
                                idx === row.index ? { ...p, valor: newValue } : p
                            )
                        );
                    }}
                    variant="standard"
                    inputProps={{ style: { maxWidth: '100px', textAlign: 'right' } }}
                />
            ),
        },
        {
            accessorKey: 'data_vencimento',
            header: 'Vencimento',
            size: 140,
            Cell: ({ cell, row }) => (
                <TextField
                    type="date"
                    value={
                        moment(cell.getValue(), 'DD/MM/YYYY', true).isValid()
                            ? moment(cell.getValue(), 'DD/MM/YYYY').format('YYYY-MM-DD')
                            : ''
                    }
                    onChange={(e) => {
                        const newDate = moment(e.target.value).format('DD/MM/YYYY');
                        setParcelas((prev) =>
                            prev.map((p, idx) =>
                                idx === row.index ? { ...p, data_vencimento: newDate } : p
                            )
                        );
                    }}
                    variant="standard"
                    inputProps={{ style: { maxWidth: '130px' } }}
                />
            ),
        },
        {
            accessorKey: 'metodo_pagamento',
            header: 'Método de Pagamento',
            size: 300,
            Cell: ({ cell, row }) => {
                const value = cell.getValue();

                return (
                    <Autocomplete
                        options={metodosPagamento || []}
                        getOptionLabel={(option) =>
                            option ? returnDescricaoMetodoPagamentoSimples(option).replace(/<br \/>/g, '\n') : ''
                        }
                        value={
                            value
                                ? metodosPagamento.find(
                                    (m) => m.id_metodo_pagamento === value.id_metodo_pagamento
                                ) || null
                                : null
                        }
                        onChange={(e, newValue) => {
                            setParcelas((prev) =>
                                prev.map((p, idx) =>
                                    idx === row.index ? { ...p, metodo_pagamento: newValue } : p
                                )
                            );
                        }}
                        isOptionEqualToValue={(option, val) =>
                            option?.id_metodo_pagamento === val?.id_metodo_pagamento
                        }
                        renderInput={(params) => (
                            <TextField {...params} variant="standard" label="Método de Pagamento" />
                        )}
                        renderOption={(props, option) => {
                            if (!option) return null;
                            const label = returnDescricaoMetodoPagamentoSimples(option) || '';
                            return (
                                <li {...props}>
                                    <div style={{ whiteSpace: 'pre-line', color: 'black' }}>
                                        {label.replace(/<br \/>/g, '\n')}
                                    </div>
                                </li>
                            );
                        }}
                        fullWidth
                    />
                );
            },
        }

    ];

    return (
        <>
            {!loading &&
                <Grid item xs={12}
                    container
                    alignItems="center"
                    justifyContent="center"
                    spacing={2}
                >


                    <Grid style={{ margin: 20 }} container spacing={2} alignItems="center">

                        <Grid item xs={5} container justifyContent="flex-start">
                            <Typography variant="h6" style={{ marginTop: 5 }}>
                                Parcelamento
                            </Typography>
                        </Grid>


                        <Grid item xs={3}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="tipo-parcelamento-label">Tipo de Parcelamento</InputLabel>
                                <Select
                                    labelId="tipo-parcelamento-label"
                                    value={tipoParcelamento}
                                    onChange={(e) => handleTipoParcelamento(e.target.value)}
                                >
                                    <MenuItem value={0}>Condições Livres</MenuItem>
                                    <MenuItem value={1}>Condições do Analista</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {tipoParcelamento === 0 &&
                            <Grid item xs={3}
                                container
                                alignItems="center"
                                justifyContent="center"
                                styke={{ padding: 10 }}
                            >

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    item xs={12}
                                >

                                    <Autocomplete
                                        id="select-metodos-pagamento"
                                        options={condicoesPagamento ? condicoesPagamento : []}
                                        fullWidth
                                        getOptionLabel={(metodo) => returnDescricaoCondicaoPagamento(metodo).replace(/<br \/>/g, '\n')}
                                        value={condicaoPagamento}

                                        onChange={(e, value) => {
                                            handleCondicaoPagamento(value);
                                        }}
                                        autoSelect
                                        filterOptions={(options, { inputValue }) => {
                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                            return options.filter((solicitante) => {
                                                const cotacaoText = returnDescricaoCondicaoPagamento(solicitante).toLowerCase();
                                                return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                            });
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label=" Condições " multiline minRows={1} />
                                        )}
                                        renderOption={(option) => (
                                            <div dangerouslySetInnerHTML={{ __html: returnDescricaoCondicaoPagamento(option).replace(/\n/g, '<br>') }} />
                                        )}

                                    />
                                </Grid>

                            </Grid>
                        }

                    </Grid>





                    <Grid item xs={4}
                        container
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Grid item xs={4}
                            container
                            alignItems="center"
                            justifyContent="center"
                        >
                            <TextField

                                variant="standard"
                                name="valorTotal"
                                label="Valor"
                                id="valorTotal"
                                value={valorTotal}
                                onChange={(e) => {
                                    // Mantém apenas números e ponto
                                    let input = e.target.value.replace(/[^0-9.]/g, '');
                                    setValorTotal(input);
                                }}
                                inputProps={{ maxLength: 600, minLength: 0 }}
                                fullWidth

                            />

                        </Grid>
                        <Grid item xs={6}
                            container
                            alignItems="center"
                            justifyContent="center"
                        >

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={tipoValor === "total"}
                                        onChange={() => setTipoValor("total")}
                                    />
                                }
                                label="Total"
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={tipoValor === "parcela"}
                                        onChange={() => setTipoValor("parcela")}
                                    />
                                }
                                label="Parcela"
                            />
                        </Grid>


                    </Grid>

                    <Grid item xs={3}
                        container
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel id="obrigatorio-selector-label">Tipo do Intervalo de Parcelamento</InputLabel>
                                <Select
                                    labelId="teste-selector-label"
                                    id="teste-selector"
                                    value={tipoIntervalo}
                                    onChange={(e) => setTipoIntervalo(e.target.value)}
                                    label="Modalidade"
                                >
                                    <MenuItem value={0}>Fixo</MenuItem>
                                    <MenuItem value={1}>Variavél</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid item xs={2}
                        container
                        alignItems="center"
                        justifyContent="center"
                    >
                        <TextField

                            variant="standard"
                            name="numeroParcelas"
                            label="Número de Parcelas"
                            id="numeroParcelas"
                            value={numeroParcelas}
                            onChange={(e) => {
                                // Remove todos os caracteres não numéricos
                                let input = e.target.value.replace(/\D/g, '');
                                // Atualiza o estado com o valor formatado
                                setNumeroParcelas(input);
                            }}
                            inputProps={{ maxLength: 600, minLength: 0 }}
                            fullWidth

                        />
                    </Grid>

                    {tipoIntervalo === 0 &&
                        <Grid item xs={3}
                            container
                            alignItems="center"
                            justifyContent="center"
                        >
                            <TextField

                                variant="standard"
                                name="intervaloParcelas"
                                label="Intervalo de Parcelas(dias)"
                                id="intervaloParcelas"
                                value={intervaloParcelas}
                                onChange={(e) => {
                                    // Remove todos os caracteres não numéricos
                                    let input = e.target.value.replace(/\D/g, '');
                                    // Atualiza o estado com o valor formatado
                                    setIntervaloParcelas(input);
                                }}
                                inputProps={{ maxLength: 600, minLength: 0 }}
                                fullWidth

                            />
                        </Grid>
                    }


                    {tipoIntervalo === 1 &&
                        <Grid item xs={3}
                            container
                            alignItems="center"
                            justifyContent="center"
                        >
                            <TextField

                                variant="standard"
                                name="intervaloVariavel"
                                label="Intervalo Variavél de Parcelas(dias)"
                                id="intervaloVariavel"
                                value={intervaloVariavel}
                                onChange={(e) => {
                                    // Remove todos os caracteres não numéricos
                                    let input = e.target.value.replace(/[^\d,]/g, '');
                                    // Atualiza o estado com o valor formatado
                                    setIntervaloVariavel(input);
                                }}
                                inputProps={{ maxLength: 600, minLength: 0 }}
                                fullWidth

                            />
                        </Grid>
                    }


                    <Grid item xs={2}
                        container
                        alignItems="center"
                        justifyContent="center"
                    >
                        <TextField

                            variant="standard"
                            name="intervaloPrimeiraParcela"
                            label="Intervalo ou Data da Primeira Parcela"
                            id="intervaloPrimeiraParcela"
                            value={intervaloPrimeiraParcela}
                            onChange={(e) => {
                                // Mantém apenas números e barra
                                let input = e.target.value.replace(/[^0-9/]/g, '');
                                setIntervaloPrimeiraParcela(input);
                            }}
                            inputProps={{ maxLength: 600, minLength: 0 }}
                            fullWidth

                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={repetirData}
                                    onChange={(e) => setRepetirData(e.target.checked)}
                                />
                            }
                            label="Repetir Data"
                        />
                    </Grid>


                    <Grid item xs={2}
                        container
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel id="obrigatorio-selector-label">Tipo da Divisão de Valores</InputLabel>
                                <Select
                                    labelId="teste-selector-label"
                                    id="teste-selector"
                                    value={tipoDivisao}
                                    onChange={(e) => setTipoDivisao(e.target.value)}
                                    label="Tipo da Divisão de Valores"
                                >
                                    <MenuItem value={0}>Igualitária</MenuItem>
                                    <MenuItem value={1}>Variavél</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>


                    {tipoDivisao === 1 &&
                        <Grid item xs={2}
                            container
                            alignItems="center"
                            justifyContent="center"
                        >
                            <TextField

                                variant="standard"
                                name="divisaoVariavel"
                                label="Divisão de Valores(porcentagem)"
                                id="divisaoVariavel"
                                value={divisaoVariavel}
                                onChange={(e) => {
                                    // Remove todos os caracteres não numéricos
                                    let input = e.target.value.replace(/[^\d,]/g, '');
                                    // Atualiza o estado com o valor formatado
                                    setDivisaoVariavel(input);
                                }}
                                inputProps={{ maxLength: 600, minLength: 0 }}
                                fullWidth

                            />
                        </Grid>
                    }

                    <Grid item xs={3}
                        container
                        alignItems="center"
                        justifyContent="center"
                        styke={{ padding: 1 }}
                    >

                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            item xs={12}
                        >

                            <Autocomplete
                                id="select-metodos-pagamento"
                                options={metodosPagamento}
                                fullWidth
                                getOptionLabel={(metodo) => returnDescricaoMetodoPagamento(metodo).replace(/<br \/>/g, '\n')}
                                value={metodoPagamento}

                                onChange={(e, value) => {
                                    setMetodoPagamento(value)
                                }}
                                autoSelect
                                filterOptions={(options, { inputValue }) => {
                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                    return options.filter((solicitante) => {
                                        const cotacaoText = returnDescricaoMetodoPagamento(solicitante).toLowerCase();
                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label=" Metodo de Pagamento " multiline minRows={1} />
                                )}
                                renderOption={(option) => (
                                    <div dangerouslySetInnerHTML={{ __html: returnDescricaoMetodoPagamento(option).replace(/\n/g, '<br>') }} />
                                )}

                            />
                        </Grid>



                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        align="center"
                        item xs={3}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={12}
                        >


                            <Autocomplete
                                id="select-fornecedor-recebedor"
                                options={lancamento.id_pre_cotacao > 0 ? [] : contasBancarias}
                                fullWidth
                                style={{ fontSize: '14px' }}
                                getOptionLabel={(conta) => returnDescricaoBanco(conta).replace(/<br \/>/g, '\n')}
                                value={contaBancariaSelecionada}
                                onChange={(e, value) => setContaBancariaSelecionada(value)}
                                getOptionSelected={(option, value) => option.id_conta_bancaria === value?.id_conta_bancaria}
                                filterOptions={(options, { inputValue }) => {
                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                    return options.filter((solicitante) => {
                                        const cotacaoText = returnDescricaoBanco(solicitante).toLowerCase();
                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                    });
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        style={{ fontSize: '14px' }}
                                        InputProps={{ ...params.InputProps, style: { fontSize: '14px' } }}
                                        InputLabelProps={{ style: { fontSize: '14px' } }}
                                        label=" Conta Bancária do Recebedor "
                                        multiline
                                        minRows={2}
                                    />
                                )}
                            />




                        </Grid>
                    </Grid>



                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={10}
                    >
                        <Button style={{ margin: 5 }}
                            variant="contained"
                            color="primary"
                            onClick={(e) => gerar()}
                        > Gerar  </Button>
                    </Grid>


                    <Grid
                        container
                        direction="row"
                        item xs={12}
                        alignItems="center"
                        justifyContent="center"
                        style={{ width: '100%', margin: 0, paddingTop: 20, color: 'black' }}
                    >

                        <MaterialReactTable
                            columns={columnsParcelas}
                            data={parcelas}
                            enableTopToolbar={false}
                            enableBottomToolbar={false}
                            enablePagination={false}
                            enableColumnFilters={false}
                            enableColumnActions={false}
                            sortable={false}
                            enableRowActions={false}
                            enableSorting={false}
                            enableRowSelection={false}
                            color={'black'}
                            paginationDisplayMode={'pages'}
                            getRowId={(row) => row.id_item_analise}
                            initialState={{
                                pagination: { pageSize: 20, pageIndex: 0 },
                                showGlobalFilter: true,
                                color: 'black'
                            }}
                            muiTableContainerProps={{ sx: { maxHeight: "3000px", color: 'black' } }}
                            muiTableBodyRowProps={{
                                sx: { height: 45, color: 'black' },
                            }}
                            enableColumnFilterModes={false}
                            enableExpandAll={true}
                            enableColumnPinning={true}
                            enableColumnResizing={true}
                            muiPaginationProps={{
                                rowsPerPageOptions: [20, 50, 100],
                                variant: 'outlined',
                            }}
                            enableFullScreenToggle={false}
                            muiTablePaperProps={({ table }) => ({
                                style: {
                                    zIndex: table.getState().isFullScreen ? 1000 : undefined,
                                    color: 'black',
                                },
                            })}
                        />

                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={10}
                    >
                        <Button style={{ margin: 5 }}
                            variant="contained"
                            color="primary"
                            onClick={(e) => salvar()}
                        > Salvar  </Button>
                    </Grid>

                </Grid>
            }
        </>
    );
}



